export default (state = [], action) => {
  switch (action.type) {
    case "CREATE_PROGRAM_HISTORY":
      return [...state, action.payload.programHistory];
    case "UPDATE_PROGRAM_HISTORY":
      return action.payload.programHistory;
    case "DELETE_PROGRAM_HISTORY":
      return state.filter((programHistory) => {
        return programHistory.id !== action.payload.programHistory.id;
      });
    default:
      return state;
  }
};
